import React, { FC, useContext, useState } from 'react'
import styles from './MediaSlider.module.scss'
import cn from 'classnames'
import { SwiperSlide, Swiper as SwiperSlider } from 'swiper/react'
import Image from '../../common/Image/Image'
import ArrowIcon from './arrow.svg'
import PlayIcon from '../../../public/static/icons/play.svg'
import Loader from '../../common/Loader/Loader'
import { MediaSliderContext } from '../../../contexts/mediaSliderProvider'
import { SwiperOptions } from 'swiper'
import { useRouter } from 'next/router'

const sliderOptions: SwiperOptions = {
  slidesPerView: 12,
  spaceBetween: 8,
  allowTouchMove: false,
  breakpoints: {
    1300: {
      slidesPerView: 12,
    },
    1080: {
      slidesPerView: 10,
    },
    992: {
      slidesPerView: 8,
    },
    768: {
      slidesPerView: 6,
      allowTouchMove: false,
    },
    500: {
      slidesPerView: 4,
    },
    300: {
      slidesPerView: 3.3,
      allowTouchMove: true,
    },
  },
}

const MediaSlider: FC<{ className?: string }> = ({ className }) => {
  const router = useRouter()
  const { slides, loading, isEnd, setIsEnd } = useContext(MediaSliderContext)
  const [swiper, setSwiper] = useState(null)
  const [activeIndex, setActiveIndex] = useState(0)

  if (loading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    )
  }

  if (!slides.length) return null

  function handlerClick(id: string, fileId: string) {
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, detailReview: id, file: fileId },
      },
      null,
      {
        scroll: false,
        shallow: true,
      },
    )
  }

  return (
    <SwiperSlider
      onInit={(s) => {
        setSwiper(s)
        setIsEnd(s.isEnd)
      }}
      {...sliderOptions}
      className={cn(styles.slider, className)}
      onSlideChange={(s) => {
        setActiveIndex(s.realIndex)
        setIsEnd(s.isEnd)
      }}
    >
      {slides.map(({ reviewId, type, src, id }, index) => (
        <SwiperSlide key={`${src}-${index}`} className={styles.slide}>
          <Image
            src={src}
            alt={`Слайд - ${index}`}
            width={100}
            height={114}
            className={styles.image}
            onClick={() => handlerClick(reviewId, id)}
          />
          {type === 'video' && (
            <div className={styles.iconContainer}>
              <PlayIcon />
            </div>
          )}
        </SwiperSlide>
      ))}
      <div
        className={cn(
          styles.decor,
          styles['decor--first'],
          activeIndex === 0 && styles['decor--hide'],
        )}
      />
      <div
        className={cn(
          styles.decor,
          styles['decor--second'],
          isEnd && styles['decor--hide'],
        )}
      />
      <div className={styles.buttons}>
        <button
          type="button"
          title="Предыдущий слайд"
          aria-label="Предыдущий слайд"
          className={cn(
            styles.button,
            styles['button--prev'],
            activeIndex === 0 && styles['button--hide'],
          )}
          onClick={() => {
            swiper?.slidePrev()
          }}
        >
          <ArrowIcon />
        </button>
        <button
          type="button"
          title="Следующий слайд"
          aria-label="Следующий слайд"
          className={cn(
            styles.button,
            styles['button--next'],
            (isEnd || swiper?.params.slidesPerView > slides.length) &&
              styles['button--hide'],
          )}
          onClick={() => {
            swiper?.slideNext()
          }}
        >
          <ArrowIcon />
        </button>
      </div>
    </SwiperSlider>
  )
}

export default MediaSlider
